import React from 'react'
import PropTypes from 'prop-types'

/**
 * Componente para mostrar un mensaje cuando no hay contenido disponible en una pestaña
 */
function EmptyTabContent({
	title,
	icon = 'folder-open',
	message = null
}) {
	return (
		<div className="text-center my-5 py-5">
			<i className={`fa fa-${icon} fa-3x text-muted mb-3`}></i>
			<h5 className="text-muted">
				{message || `No hay ${title.toLowerCase()} para mostrar`}
			</h5>
		</div>
	)
}

EmptyTabContent.propTypes = {
	/** Título del contenido que falta */
	title: PropTypes.string.isRequired,
	/** Icono de Font Awesome a mostrar (sin el prefijo fa-) */
	icon: PropTypes.string,
	/** Mensaje personalizado (opcional) */
	message: PropTypes.string
}

export default EmptyTabContent